import React from 'react';
import { FilterToken } from '../searchState';
import './FilterTokenRow.css';

interface FilterTokenRowProps {
  tokens: FilterToken[];
  onClear: (token: FilterToken) => void;
  onClearAll?: () => void;
  /** Horizontal scroll instead of wrapping, for the mobile header row. */
  scrollable?: boolean;
}

/**
 * The active filters, one removable token each.
 *
 * Tokens are derived from the same state the filter panel renders, so the two
 * cannot drift apart — there is nothing to keep in sync.
 */
export const FilterTokenRow: React.FC<FilterTokenRowProps> = ({
  tokens,
  onClear,
  onClearAll,
  scrollable,
}) => {
  if (tokens.length === 0) return null;

  return (
    <div className={`filter-token-row ${scrollable ? 'scrollable' : ''}`}>
      {tokens.map((token) => (
        <button
          key={token.id}
          type="button"
          className="filter-token"
          onClick={() => onClear(token)}
          aria-label={`Remove filter ${token.label}`}
        >
          <span className="filter-token-label">{token.label}</span>
          {/* A text glyph rather than the shared close.svg: that asset's path is
              a hardcoded fill="#1F1F1F", which is invisible on a dark token. */}
          <span className="filter-token-close" aria-hidden="true">
            ×
          </span>
        </button>
      ))}

      {onClearAll && tokens.length > 1 && (
        <button type="button" className="filter-token-clear-all" onClick={onClearAll}>
          Clear all
        </button>
      )}
    </div>
  );
};

export default FilterTokenRow;
